import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import { identity, pickBy } from "lodash";
import Amplitude from "./amplitude";
import { ENVIRONMENT } from "./constants";
import { fullName } from "./helpers/text";
const getIdForPendo = id => {
  return ENVIRONMENT === "production" ? id : `${ENVIRONMENT}-${id}`;
};
const getAccountDetailsForPendo = (accountType, brokerage) => {
  return accountType !== "client" ? {
    id: getIdForPendo((brokerage == null ? void 0 : brokerage.brokerageId) || ""),
    name: (brokerage == null ? void 0 : brokerage.name) || "",
    environment: ENVIRONMENT
  } : {};
};
const getVisitorDetailsForPendo = (userDetails, accountDetails, accountPreferences) => {
  var _userDetails$address$, _userDetails$address, _context;
  const visitorDetails = _objectSpread(_objectSpread({}, pickBy(accountDetails, identity)), {}, {
    id: getIdForPendo(userDetails.username),
    email: userDetails.email,
    full_name: fullName(userDetails),
    role: accountDetails.accountType,
    locale: accountDetails.localeLanguage,
    province: (_userDetails$address$ = (_userDetails$address = userDetails.address) == null ? void 0 : _userDetails$address.province) != null ? _userDetails$address$ : "N/A",
    environment: ENVIRONMENT
  });
  if (_includesInstanceProperty(_context = ["broker", "agent"]).call(_context, accountDetails.accountType)) {
    var _accountPreferences$f, _accountPreferences$t;
    visitorDetails.account_plan = accountDetails.accountPlan;
    visitorDetails.last_logged_in = accountDetails.lastLoggedIn || "";
    visitorDetails.feature_discovery_enabled = (_accountPreferences$f = accountPreferences == null ? void 0 : accountPreferences.featureDiscovery) != null ? _accountPreferences$f : false;
    visitorDetails.tutorials_enabled = (_accountPreferences$t = accountPreferences == null ? void 0 : accountPreferences.tutorial) != null ? _accountPreferences$t : false;
  }
  return visitorDetails;
};
export default class PendoUtils {
  static prepare() {
    pendo.initialize();
  }
  static startSession(sessionDetails) {
    try {
      const {
        userDetails,
        accountDetails,
        brokerageDetails = null,
        accountPreferences = null
      } = sessionDetails;
      const brokerage = brokerageDetails ? brokerageDetails.tiedBrokerages[0] : null;
      const pendoAccountDetails = getAccountDetailsForPendo(accountDetails.accountType, brokerage);
      const pendoVisitorDetails = getVisitorDetailsForPendo(userDetails, accountDetails, accountPreferences);
      pendo.updateOptions({
        visitor: pendoVisitorDetails,
        account: pendoAccountDetails
      });
    } catch (error) {
      Amplitude.logHandledError(error);
    }
  }
  static updateVisitor(sessionDetails) {
    try {
      const {
        userDetails,
        accountDetails,
        accountPreferences = null
      } = sessionDetails;
      const pendoVisitorDetails = getVisitorDetailsForPendo(userDetails, accountDetails, accountPreferences);
      pendo.updateOptions({
        visitor: pendoVisitorDetails
      });
    } catch (error) {
      Amplitude.logHandledError(error);
    }
  }
}